/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EntityTreeComponent} from './entity-tree/entity-tree.component';
import {EntityElementComponent} from './entity-element/entity-element.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {EntityTreeHeaderComponent} from './entity-tree-header/entity-tree-header.component';
import {EntityTreeNodeComponent} from './entity-tree-node/entity-tree-node.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ContextMenuModule} from '../context-menu/context-menu.module';
import {WarningsModule} from '../warnings/warnings.module';

import {ConfirmModalComponent} from '../confirm-modal/confirm-modal/confirm-modal.component';
import {ConfirmModalModule} from '../confirm-modal/confirm-modal/confirm-model.module';
import {SegmentedButtonModule} from '../segemented-button/segmented-button.module';
import {EntityTreeTabsComponent} from './entity-tree-tabs/entity-tree-tabs.component';
import {DragAndDropGridModule} from '../drag-and-drop-grid/drag-and-drop-grid.module';

@NgModule({
    declarations: [
        EntityTreeComponent,
        EntityElementComponent,
        EntityTreeHeaderComponent,
        EntityTreeNodeComponent,
        EntityTreeTabsComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        DragDropModule,
        NgbDropdownModule,
        ContextMenuModule,
        WarningsModule,
        ConfirmModalModule,
        SegmentedButtonModule,
        DragAndDropGridModule
    ],
    exports: [EntityTreeComponent, EntityElementComponent]
})

export class EntityTreeModule {
}
